
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7455"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7455"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kSzIz", function(module, exports) {

$parcel$export(module.exports, "BASE_URL", () => $f3348e9e3764687e$export$ca6dda5263526f75);
// baseURL.js
const $f3348e9e3764687e$export$ca6dda5263526f75 = window.location.hostname === "localhost" ? "http://localhost:3000/api/v1" : "https://dev-irecruit-api.webpipl.com/api/v1";

});

parcelRegister("91V5O", function(module, exports) {

$parcel$export(module.exports, "showSpinner", () => $69307e77fa35369d$export$2a7a135fa1ec651f);
$parcel$export(module.exports, "hideSpinner", () => $69307e77fa35369d$export$95fec50f68454318);
function $69307e77fa35369d$export$2a7a135fa1ec651f() {
    const spinner = document.getElementById("spinnerOverlay");
    if (spinner) spinner.classList.remove("hidden");
}
function $69307e77fa35369d$export$95fec50f68454318() {
    const spinner = document.getElementById("spinnerOverlay");
    if (spinner) spinner.classList.add("hidden");
}

});

// public/scripts/freelancer-register.js

var $kSzIz = parcelRequire("kSzIz");

var $91V5O = parcelRequire("91V5O");
console.log("[freelancer-register] script loaded");
console.log("[freelancer-register] Using BASE_URL:", (0, $kSzIz.BASE_URL));
// Wait until DOM ready
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $67c589c349fa31c9$var$initFreelancerRegistration);
else $67c589c349fa31c9$var$initFreelancerRegistration();
function $67c589c349fa31c9$var$initFreelancerRegistration() {
    console.log("[freelancer-register] Initializing form...");
    const form = document.getElementById("freelancerForm");
    let errorDiv = document.getElementById("errorContainer");
    if (!form) {
        console.warn("\u26A0\uFE0F freelancerForm not found in DOM");
        return;
    }
    // Ensure we have a visible error container
    if (!errorDiv) errorDiv = $67c589c349fa31c9$var$createErrorDiv(form);
    const submitBtn = form.querySelector("button[type='submit']") || form.querySelector("button");
    if (!submitBtn) console.warn("\u26A0\uFE0F Submit button not found in form");
    console.log("\u2705 Freelancer form ready and handler attached");
    form.addEventListener("submit", (e)=>$67c589c349fa31c9$var$handleFormSubmit(e, form, errorDiv, submitBtn));
}
function $67c589c349fa31c9$var$createErrorDiv(form) {
    const div = document.createElement("div");
    div.classList.add("text-red-600", "text-sm", "space-y-1", "mt-2");
    form.parentNode.insertBefore(div, form.nextSibling);
    return div;
}
function $67c589c349fa31c9$var$handleFormSubmit(e, form, errorDiv, submitBtn) {
    e.preventDefault();
    e.stopPropagation();
    errorDiv.innerHTML = "";
    const payload = $67c589c349fa31c9$var$extractFormData(form);
    const validationErrors = $67c589c349fa31c9$var$validateFormData(payload);
    if (validationErrors.length > 0) {
        $67c589c349fa31c9$var$displayErrors(errorDiv, validationErrors);
        return;
    }
    $67c589c349fa31c9$var$registerFreelancer(payload, form, errorDiv, submitBtn);
}
function $67c589c349fa31c9$var$extractFormData(form) {
    return {
        name: form.name?.value?.trim() || "",
        email: form.email?.value?.trim() || "",
        phone: form.phone?.value?.trim() || "",
        password: form.password?.value || "",
        confirmPassword: form.confirmPassword?.value || ""
    };
}
function $67c589c349fa31c9$var$validateFormData({ name: name, email: email, phone: phone, password: password, confirmPassword: confirmPassword }) {
    const errors = [];
    if (name.length < 3) errors.push("Name must be at least 3 characters.");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.push("Invalid email format.");
    if (!/^[0-9]{10,15}$/.test(phone)) errors.push("Phone must be 10\u201315 digits.");
    if (password.length < 6) errors.push("Password must be at least 6 characters.");
    if (!confirmPassword) errors.push("Confirm Password is required.");
    if (password !== confirmPassword) errors.push("Passwords do not match.");
    return errors;
}
function $67c589c349fa31c9$var$displayErrors(errorDiv, messages) {
    errorDiv.innerHTML = messages.map((e)=>`<div>\u{2022} ${e}</div>`).join("");
}
async function $67c589c349fa31c9$var$registerFreelancer(payload, form, errorDiv, submitBtn) {
    try {
        (0, $91V5O.showSpinner)(submitBtn, "Registering...");
        const res = await fetch(`${(0, $kSzIz.BASE_URL)}/auth/registration/freelancer`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });
        const data = await res.json();
        if (!res.ok) {
            const serverErrors = $67c589c349fa31c9$var$extractServerErrors(data);
            $67c589c349fa31c9$var$displayErrors(errorDiv, serverErrors);
            return;
        }
        console.log("\u2705 Registered successfully!");
        form.reset();
        window.location.href = "/app/pages/login.html";
    } catch (err) {
        console.error("\u274C API error", err);
        $67c589c349fa31c9$var$displayErrors(errorDiv, [
            `\u{274C} ${err.message}`
        ]);
    } finally{
        (0, $91V5O.hideSpinner)(submitBtn);
    }
}
function $67c589c349fa31c9$var$extractServerErrors(data) {
    const serverErrors = new Set();
    if (typeof data.message === "string") {
        const msg = data.message.trim();
        const isSafe = msg.length < 200 && !msg.toLowerCase().includes("enoent") && !msg.toLowerCase().includes("file") && !msg.toLowerCase().includes("directory");
        serverErrors.add(isSafe ? msg : "Something went wrong. Please try again later.");
    }
    if (Array.isArray(data.errors)) data.errors.forEach((e)=>{
        if (typeof e.message === "string" && e.message.trim().length > 0) serverErrors.add(e.message.trim());
    });
    if (serverErrors.size === 0) serverErrors.add("Something went wrong. Please try again later.");
    return [
        ...serverErrors
    ];
}


//# sourceMappingURL=register-freelance-recruiter.bf862db6.js.map
